/* CONVERTIX-IL — theme.js */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---- scroll reveal ---- */
  function reveals() {
    var els = document.querySelectorAll('[data-rv]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = en.target.getAttribute('data-rv') || 0;
        setTimeout(function () { en.target.classList.add('in'); }, d * 90);
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- sticky header state ---- */
  function stickyHeader() {
    var h = document.querySelector('.hdr');
    if (!h) return;
    var on = function () { h.classList.toggle('stuck', window.scrollY > 24); };
    on();
    window.addEventListener('scroll', on, { passive: true });
  }

  /* ---- mega menu ---- */
  function mega() {
    var items = document.querySelectorAll('.navi--has');
    items.forEach(function (it) {
      var btn = it.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = it.classList.contains('open');
        items.forEach(function (o) { o.classList.remove('open'); });
        it.classList.toggle('open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
    document.addEventListener('click', function () {
      items.forEach(function (o) {
        o.classList.remove('open');
        var b = o.querySelector('button');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (o) { o.classList.remove('open'); });
      document.body.classList.remove('navopen');
    });
  }

  /* ---- mobile drawer ---- */
  function drawer() {
    var b = document.querySelector('.burger');
    if (!b) return;
    b.addEventListener('click', function () {
      var open = document.body.classList.toggle('navopen');
      b.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---- stat count-up ---- */
  function counters() {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var raw = el.getAttribute('data-count');
        var target = parseFloat(String(raw).replace(/[^\d.]/g, ''));
        if (isNaN(target)) { io.unobserve(el); return; }
        var pre = String(raw).split(/[\d]/)[0] || '';
        var post = String(raw).replace(/^[^\d]*[\d.,]+/, '');
        var dec = (String(target).split('.')[1] || '').length;
        var t0 = null, dur = 1500;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var v = (target * eased).toFixed(dec);
          el.textContent = pre + Number(v).toLocaleString('he-IL', { minimumFractionDigits: dec }) + post;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- live session clock (telemetry HUD) ---- */
  function clock() {
    var els = document.querySelectorAll('[data-clock]');
    if (!els.length) return;
    var t = 0;
    setInterval(function () {
      t++;
      var h = String(Math.floor(t / 3600)).padStart(2, '0');
      var m = String(Math.floor((t % 3600) / 60)).padStart(2, '0');
      var s = String(t % 60).padStart(2, '0');
      els.forEach(function (e) { e.textContent = h + ':' + m + ':' + s; });
    }, 1000);
  }

  ready(function () {
    reveals();
    stickyHeader();
    mega();
    drawer();
    counters();
    clock();
  });
})();
